import Swiper, { Autoplay, Mousewheel } from "swiper";
import "swiper/swiper.min.css";

export default class partnersSwiper {
  constructor(el) {
    this.el = el;
    this.slider = null;
    this.init();
  }

  init() {
    this.slider = new Swiper(this.el, {
      slidesPerView: "2",
      spaceBetween: 10,
      autoplay: {
        delay: 3000,
      },
      modules: [Autoplay, Mousewheel],
      mousewheel: {
        releaseOnEdges: true,
      },
      grabCursor: true,
      breakpoints: {
        576: {
          slidesPerView: "2",
        },
        768: {
          slidesPerView: "4",
        },
        1300: {
          slidesPerView: "6",
        },
      },
    });
  }
}
